import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNodeStyle } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";

const HideShow = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const styles = useAppSelector(getSelectedNodeStyle);
    const toggleCallback = (checked: boolean) => {
        if (checked) {
            dispatch(updateNodeProperty({ propertyPath: ["attr", "style", "display"], value: "none" }));
        } else {
            dispatch(updateNodeProperty({ propertyPath: ["attr", "style", "display"], value: "flex" }));
        }
    };

    return (
        <SidebarCollapse title="Hide/Show" parent={parent}>
            <Toggle label="Hide on layout" checked={styles?.display === "none"} callback={toggleCallback}></Toggle>
        </SidebarCollapse>
    );
};

export default HideShow;
